import {IRule} from '@mintdata-wsp/common/controllers/spreadsheet/functions/util/text/IRule';

export class PaddingRule implements IRule
{
    private readonly _regexp:RegExp = /^0+\.?0*$/;

    public apply(number:number, format:string):string
    {
        const parts = format.split('.');
        const integerDigits = parts[0].length;
        const fractionDigits = parts.length > 1 ? parts[1].length : 0;

        if( fractionDigits == 0 )
        {
            number = Math.round(number);
            return PaddingRule._lpad(String(number), integerDigits);
        }

        const integerPart = Math.floor(number);
        const actualIntegerDigits = PaddingRule._len(integerPart);
        const fractionPart = (number - integerPart).toFixed(fractionDigits).substr('0.'.length);

        return actualIntegerDigits > integerDigits
            ? integerPart + '.' + fractionPart
            : PaddingRule._lpad(String(integerPart), integerDigits) + '.' + fractionPart;
    }

    private static _len(inputNumber:number)
    {
        let len = 0;

        while( inputNumber > 0 )
            inputNumber /= 10;

        return len;
    }

    private static _lpad(inputString:string, length:number):string
    {
        while( inputString.length < length )
            inputString = '0' + inputString;

        return inputString;
    }

    public matches(format:string):boolean
    {
        return this._regexp.test(format);
    }
}
